<script>
import { mapActions } from 'vuex'
export default {
  name: 'ConsultantDetails',
  props: {
    name: {
      type: String,
      default: '',
    },

    id: {
      type: Number,
      default: -1,
    },
  },
  data: function() {
    return { consultantName: '' }
  },
  mounted: function() {
    this.fetchUser(this.id).then((response) => {
      this.consultantName = response.data.displayName
    })
  },
  methods: { ...mapActions({ fetchUser: 'users/fetchStaffById' }) },
}
</script>

<template>
  <div class="consultantInfo"> {{ consultantName }} </div>
</template>

<style lang="scss" scoped>
.consultantInfo {
  display: inline-block;
}
</style>
